import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../components/appIcon';
import Image from 'components/appImage';
import cctv from 'assets/images/cctv.jpg';
const AuthenticationLayout = ({ children, title, subtitle, showBackToLogin = false }) => {
  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4 lg:p-8 space-y-6 lg:space-y-0 lg:flex lg:space-x-12 w-full">
      <div className="hidden lg:flex w-1/2 justify-center">
          <div className="relative w-full h-[600px] rounded-xl overflow-hidden shadow-lg">
            {/* Placeholder for CCTV attendance image */}
            <div className="absolute inset-0 bg-gradient-to-r from-blue-900/70 to-purple-900/70 flex items-center justify-center">
              <div className="text-center text-white p-8">
                <Icon name="Video" size={64} className="mx-auto mb-6" />
                <h2 className="text-3xl font-bold mb-4">Employees Face recognition - Attendance System</h2>
                <p className="text-lg opacity-90">
                  Advanced facial recognition technology for accurate and efficient attendance tracking.
                </p>
              </div>
            </div>
            {/* This would be replaced with an actual image */}
            <div className="w-full h-full bg-gray-300 flex items-center justify-center">
              <Image
                src={cctv}
                alt="CCTV Attendance"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
      </div>
      {/* Content */}
      <div className="space-y-4 w-full max-w-md lg:w-1/2">
        <div className="text-center">
          <h1 className="text-2xl font-bold text-foreground">{title}</h1>
          <p className="text-sm text-muted-foreground">{subtitle}</p>
        </div>
        {children}
      </div>
      {/* Back to Login Link */}
      {showBackToLogin && (
        <div className="mt-6 text-center">
          <Link
            to="/login"
            className="inline-flex items-center space-x-2 text-sm text-primary hover:text-primary/80 enterprise-transition"
          >
            <Icon name="ArrowLeft" size={16} />
            <span>Back to Login</span>
          </Link>
        </div>
      )}
    </div>

  );
};

export default AuthenticationLayout;